import * as React from 'react'
import { t } from 'ttag'
import { getFormattedUrl, getIntegrationType, integrationUrl } from '../../common/helpers/integrationUrl'
import { openUrl } from '../../common/helpers/routeHelpers'
import { ROUTES } from '../../common/Routes/routePaths'
import { Button } from '../../components/Button/Button'
import { Card } from '../../components/Card/Card'
import Loader from '../../components/Loader/Loader'
import {
  FinalizeGarminIntegration$Request,
  ServiceProvider,
  SetUserThirdPartyIntegration$Request,
} from '../../services/api.types'
import { Preferences } from '@capacitor/preferences'
import { isNative } from '../../common/helpers/isNative'

export interface IDispatchProps {
  setIntegration(payload: SetUserThirdPartyIntegration$Request): void
  initializeGarminIntegration(): void
  finalizeGarminIntegration(payload: FinalizeGarminIntegration$Request): void
}

type IGoogleFitProps = IDispatchProps

export class IntegrationProxy extends React.Component<IGoogleFitProps> {
  async componentDidMount(): Promise<void> {
    const { setIntegration, initializeGarminIntegration, finalizeGarminIntegration } = this.props
    const { authorizationCode, serviceProvider, oauthToken, oauthVerifierValue } = await getFormattedUrl()
    const {
      type,
      fullScope,
      withDistance,
      withSleep,
    }: { type: string; fullScope: boolean; withDistance: boolean; withSleep: boolean } = getIntegrationType()

    // Redirect to app if we are in a browser but did not start here (its in-app browser) and have a integration token.
    // Return URL for GOOGLE_FIT, FITBIT and POLAR have authorizationCode. GARMIN has oauthToken and oauthVerifierValue.
    const { value: isIntegrationHost } = await Preferences.get({ key: 'isIntegrationHost' })
    if (!isIntegrationHost && (authorizationCode || (oauthToken && oauthVerifierValue))) {
      await openUrl(`yumuuv://settings${window.location.search}`)
    }
    // This does not seem to work anymore (at least in iOS).
    else if (!!(window.navigator as any).standalone && authorizationCode) {
      await openUrl(`yumuuv://settings${window.location.search}`)
    }
    // Finishes integration for GARMIN.
    else if (serviceProvider === ServiceProvider.GARMIN && oauthToken && oauthVerifierValue) {
      finalizeGarminIntegration({
        redirectUrl: `${window.location.origin}${ROUTES.REGISTER_USER.to}`,
        oauthToken,
        oauthVerifierValue,
      })
    }
    // Finishes integration for GOOGLE_FIT, FITBIT, POLAR and HUAWEI.
    else if (authorizationCode) {
      const webProxy = !isNative() ? '/web-proxy' : ''
      const redirectUrl = `${window.location.origin}${webProxy}${ROUTES.INTEGRATION_PROXY.to}`
      setIntegration({ authorizationCode, serviceProvider, redirectUrl })
    }
    // Starts GARMIN integration.
    else if (type === ServiceProvider.GARMIN) {
      await Preferences.set({ key: 'isIntegrationHost', value: 'true' })
      await Preferences.set({ key: 'serviceProvider', value: String(type) })
      initializeGarminIntegration()
    }
    // Starts GOOGLE_FIT, FITBIT, POLAR or HUAWEI integration.
    else {
      await Preferences.set({ key: 'isIntegrationHost', value: 'true' })
      await openUrl(integrationUrl({ type, fullScope, withDistance, withSleep }))
    }
  }

  render() {
    return (
      <Card className="card--center-content">
        <Loader />

        <p>{t`Please wait, integration with third party in progress`}</p>

        <div>
          <Button text={t`Cancel`} url={ROUTES.REGISTER_USER.to} link={true} />
        </div>
      </Card>
    )
  }
}
